import React, { Fragment } from 'react';
import * as PropTypes from 'prop-types';
import Button from '../Button';
import Close from '../Close';
import Icon from '../../../Icon';
import { gotoLogin } from '../../../../util-lib/login/login-controller';
import './style.scss';

class ZzbExchange extends React.Component {
  static propTypes = {
    exchangingGoods: PropTypes.shape({}),
    isLogin: PropTypes.bool,
    phone: PropTypes.string,
    error: PropTypes.string,
    readOnly: PropTypes.bool,
    isReceiving: PropTypes.bool,
    onInputChange: PropTypes.func,
    onEdit: PropTypes.func,
    onSubmit: PropTypes.func,
    onClose: PropTypes.func
  }

  renderTipsByPrizeType = (prizeType) => {
    if (prizeType === 1) {
      return (
        <p>
          领取后将在
          <em>24h</em>
          内发放到您的账户里
          <br />
          可在「我的-优惠券」中查看
        </p>
      );
    }

    return (
      <p>
        奖品兑换码将在
        <em>24h</em>
        内发送到您的手机号
      </p>
    );
  }

  handleFocus = (e) => {
    const { target } = e;
    if (target.scrollIntoView) {
      target.scrollIntoView();
    }
  }

  render() {
    const {
      exchangingGoods, isLogin, phone, readOnly, onInputChange, onEdit, onClose,
      isReceiving, onSubmit, error
    } = this.props;

    const { awardType: type, price } = exchangingGoods;

    return (
      <article className="ap-zzb-exchange">
        <Close className="ap-receive-close" onClick={onClose} />
        <section className="ap-zzb-exchange-gift-icon" />
        <section className="ap-receive-main ap-zzb-exchange-main">
          <h3>
            本次兑换将消耗
            {price}
            猪猪币
          </h3>
          {
            isLogin ? (
              <Fragment>
                {this.renderTipsByPrizeType(type)}
                <section className="ap-receive-form">
                  {
                    type === 2 && (
                      <section className="ap-receive-form-input">
                        <input
                          className="J-punch-phone-input"
                          placeholder="请输入手机号"
                          maxLength={11}
                          readOnly={readOnly}
                          value={phone}
                          pattern="\d*"
                          onChange={onInputChange}
                          onFocus={this.handleFocus}
                        />
                        {
                          readOnly && (
                            <div className="ap-receive-form-edit" onClick={onEdit}>
                              <Icon name="edit" className="icon-edit" />
                            </div>
                          )
                        }
                      </section>
                    )
                  }
                  {
                    error && (
                      <p className="ap-receive-form-error">{error}</p>
                    )
                  }
                  <Button
                    className="ap-receive-button"
                    text={isReceiving ? '兑换中...' : '确认兑换'}
                    onClick={isReceiving ? null : onSubmit}
                  />
                </section>
              </Fragment>
            ) : (
              <Fragment>
                <p>
                  登录后，奖品兑换码将在
                  <em>24h</em>
                  内通过手机
                  <br />
                  短信发到您的手机~
                </p>
                <Button className="ap-receive-button" text="登录并领取" onClick={gotoLogin} />
              </Fragment>
            )
          }
        </section>
      </article>
    );
  }
}

export default ZzbExchange;
